(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-comparison"] && !Shopify.designMode) return;
  try {
    
  /*
    Bundled once per page by Shopify regardless of how many instances exist.
    Custom elements upgrade automatically when the theme editor re-renders the
    section, so no DOMContentLoaded / shopify:section:load wiring is needed.
  */
  if (!customElements.get('product-comparison')) {
    customElements.define(
      'product-comparison',
      class ProductComparison extends HTMLElement {
        connectedCallback() {
          this.select = this.querySelector('[data-compare-select]');
          if (!this.select) return;

          this.onChange = () => this.show(this.select.value);
          this.select.addEventListener('change', this.onChange);

          // Browsers can restore a previous <select> value on back/forward navigation;
          // sync the visible column to whatever the control actually shows.
          this.show(this.select.value);
        }

        disconnectedCallback() {
          this.select?.removeEventListener('change', this.onChange);
        }

        show(handle) {
          this.querySelectorAll('[data-compare-handle]').forEach((col) => {
            col.hidden = col.dataset.compareHandle !== handle;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
